import React, { useState } from "react";
import { MdCheckBox, MdOutlineCheckBoxOutlineBlank } from "react-icons/md";
import EAButton from "../../../shared/Buttons/EAButton";
import { Instructor } from "../../../../models/Instructor";

interface IProps {
  title: string;
  data: Instructor[];
  onSelect: (value: Instructor) => void;
}
const InstructorSortModal: React.FC<IProps> = ({ title, data, onSelect }) => {
  const [open, setIndex] = useState(60);

  if (!data || data.length === 0) {
    return null;
  }

  return (
    <>
      <p>{title}</p>
      <div className="SortModal">
        {data.map((item, index) => (
          <EAButton
            key={index}
            onClick={() => {
              setIndex(index);
              onSelect(item);
            }}
            title={`${item.firstName}`}
            startIcon={index === open ? <MdCheckBox /> : <MdOutlineCheckBoxOutlineBlank />}
            variant="text"
            noMargins
          />
        ))}
      </div>
    </>
  );
};

export default InstructorSortModal;
